import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 39.997c11.044 0 19.997-8.953 19.997-19.997S31.044.003 20 .003.003 8.956.003 20 8.956 39.997 20 39.997Z"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M2.682 10.002A20.01 20.01 0 0 0 .67 14.863l33.443 19.309a20.012 20.012 0 0 0 3.205-4.173L2.682 10.002Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M29.999 2.682C21.997-1.938 12.13-.398 5.887 5.828L39.33 25.136C41.6 16.616 38 7.302 29.999 2.682ZM10.002 37.318c8 4.62 17.867 3.08 24.111-3.146L.67 14.864C-1.6 23.384 2 32.698 10.002 37.318Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M21.304 11.306h-2.608v2.608h-3.043c0 .6.523 1.087 1.123 1.087h-.036c0 .6.486 1.087 1.086 1.087 0 .525.374.964.87 1.065v6.174a5.654 5.654 0 0 1-3.668-8.189A6.932 6.932 0 0 0 13.044 20c0 2.077.911 3.942 2.355 5.217h-1.485v.87h-1.739v2.608h5.217v-.87h5.216v.87h5.217v-2.609h-1.739v-.87h-1.485A6.939 6.939 0 0 0 26.956 20a6.932 6.932 0 0 0-1.984-4.862 5.654 5.654 0 0 1-3.668 8.188v-6.173c.496-.101.87-.54.87-1.065.6 0 1.086-.487 1.086-1.087h-.036c.6 0 1.123-.487 1.123-1.087h-3.043v-2.608Z"
}, null, -1), i = [
  o,
  n,
  c,
  s
];
function d(_, r) {
  return e(), l("svg", h, [...i]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
